export const AUTH_TYPE = [
  { name: 'Admin権限', value: 'SYSTEM_ADMIN' },
  { name: '現場管理者', value: 'WORK_SITE_ADMIN' },
  { name: '一般監視者', value: 'NORMAL_MONITOR' },
];
